import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import EmployerForm from './EmployersForm';
import EmployeeForm from './EmployeeForm';
import '../assets/styles/JoinPage.css'; // Import the CSS file

const JoinPage = () => {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
    };

    return (
        <Container className="join-page">
            {!selectedOption && (
                <Row className="justify-content-center">
                    <Col md={4}>
                        <Card className="option-card" onClick={() => handleOptionClick('findJob')}>
                            <Card.Img variant="top" src="https://via.placeholder.com/300x200" />
                            <Card.Body>
                                <Card.Title>Find Job</Card.Title>
                                <Card.Text>
                                    Create a profile to apply for jobs and get hired.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="option-card" onClick={() => handleOptionClick('postJob')}>
                            <Card.Img variant="top" src="https://via.placeholder.com/300x200" />
                            <Card.Body>
                                <Card.Title>Post Job</Card.Title>
                                <Card.Text>
                                    Create a profile to post job listings and hire employees.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
            {selectedOption === 'findJob' && <EmployeeForm />}
            {selectedOption === 'postJob' && <EmployerForm />}
        </Container>
    );
};

export default JoinPage;
